import { rem } from 'polished'
import { media } from './media'
import { InterpolationValue } from 'styled-components'
import { css } from './themedStyledComponents'

export enum FontFamily {
  base = "'Cera', sans-serif",
  cooper = "'Cooper', sans-serif",
}

export interface TypiValue {
  size: number
  lineHeight?: number
  letterSpacing: number | null
  family: FontFamily
}

export interface TypiSize {
  default: TypiValue
  desktop: TypiValue
}

interface TypiConfig {
  [size: string]: TypiSize
}

export const typi: TypiConfig = {
  // Body
  base: {
    default: {
      size: 16,
      letterSpacing: null,
      family: FontFamily.base,
    },
    desktop: {
      size: 16,
      letterSpacing: null,
      family: FontFamily.base,
    },
  },
  // Tiny
  tiny: {
    default: {
      size: 12,
      letterSpacing: null,
      family: FontFamily.base,
    },
    desktop: {
      size: 12,
      letterSpacing: null,
      family: FontFamily.base,
    },
  },
  // Body 2 / Menu & Caption
  small: {
    default: {
      size: 14,
      letterSpacing: null,
      family: FontFamily.base,
    },
    desktop: {
      size: 14,
      letterSpacing: null,
      family: FontFamily.base,
    },
  },
  // Subheader
  large: {
    default: {
      size: 20,
      letterSpacing: null,
      family: FontFamily.base,
    },
    desktop: {
      size: 20,
      letterSpacing: null,
      family: FontFamily.base,
    },
  },
  // Title
  h3: {
    default: {
      size: 25,
      letterSpacing: null,
      family: FontFamily.base,
    },
    desktop: {
      size: 25,
      letterSpacing: null,
      family: FontFamily.base,
    },
  },
  // Header
  h2: {
    default: {
      size: 31,
      letterSpacing: null,
      family: FontFamily.base,
    },
    desktop: {
      size: 31,
      letterSpacing: null,
      family: FontFamily.base,
    },
  },
  // Title Home
  titleHome: {
    default: {
      size: 38,
      letterSpacing: null,
      family: FontFamily.base,
    },
    desktop: {
      size: 38,
      letterSpacing: null,
      family: FontFamily.base,
    },
  },
  // Home Header
  h1: {
    default: {
      size: 49,
      letterSpacing: null,
      family: FontFamily.base,
    },
    desktop: {
      size: 49,
      letterSpacing: null,
      family: FontFamily.base,
    },
  },
}

export type TextFontWeight = 'light' | 'regular' | 'medium' | 'bold'

export enum FontWeight {
  light = 300,
  regular = 400,
  medium = 500,
  bold = 700,
}

type FontName = (fontWeight?: FontWeight | TextFontWeight) => InterpolationValue[]

export interface FontInterface {
  base: FontName
  tiny: FontName
  small: FontName
  large: FontName
  h3: FontName
  h2: FontName
  titleHome: FontName
  h1: FontName
}

export const font: FontInterface = {
  base: generateResponsiveFontSize(typi.base),
  tiny: generateResponsiveFontSize(typi.tiny),
  small: generateResponsiveFontSize(typi.small),
  large: generateResponsiveFontSize(typi.large),
  h3: generateResponsiveFontSize(typi.h3),
  h2: generateResponsiveFontSize(typi.h2),
  titleHome: generateResponsiveFontSize(typi.titleHome),
  h1: generateResponsiveFontSize(typi.h1),
}

function generateResponsiveFontSize(size: TypiSize) {
  const fontBaseCss = css`
    ${generateFontSize(size.default)};
    ${media.desktop`
      ${generateFontSize(size.desktop)}
    `};
  `
  return (fontWeight: FontWeight | TextFontWeight = FontWeight.regular) => css`
    font-weight: ${typeof fontWeight === 'string' ? FontWeight[fontWeight] : fontWeight};
    ${fontBaseCss};
  `
}

function generateFontSize(value: TypiValue) {
  return css`
    font-family: ${value.family};
    font-size: ${rem(value.size)};
    line-height: ${Math.round((1.5 + 0.2 * (400 / (value.size * 30) - 1)) * 1000) / 1000};
    ${!!value.letterSpacing && `letter-spacing: ${value.letterSpacing}px`};
  `
}



// WEBPACK FOOTER //
// ./src/utils/theme/font.ts